import { Table } from "@/features/Table";
import { type ClientPortfolio, client_portfolios_columns } from "./columns";
import {
  type FilterClientPortfoliosSchema,
  FilterClientPortfolios,
} from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "client_portfolios";

export const ClientPortfoliosTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<ClientPortfolio, FilterClientPortfoliosSchema>
      label="Client Portfolios"
      client={client}
      table_name={table_name}
      columns={client_portfolios_columns}
      filter={<FilterClientPortfolios />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
